import { render, staticRenderFns } from "./detalleUsuario.vue?vue&type=template&id=9446e4e4&"
import script from "./detalleUsuario.vue?vue&type=script&lang=js&"
export * from "./detalleUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports